import PoojaReview from "@/components/Reviews/PoojaReview";

export { PoojaReview };
